<template>
  <span v-if="params.value" class="block">
    {{ minimalTimeWithinToday(formatValue(params.value)) }}
  </span>
  <span v-else>-</span>
</template>
<script setup>
import { minimalTimeWithinToday } from '@/composeables/filters';
import { computed } from 'vue';

const props = defineProps({
  params: Object
});

const isUnixTimestamp = computed(() => {
  if (props.params.value) {
    return typeof props.params.value === 'number';
  }
  return false;
});
function formatValue(value) {
  if (!isUnixTimestamp.value) {
    value = new Date(value).getTime();
  }
  return value.toString().length > 12 ? value : value * 1000;
}
</script>
